import { IFavoriteOrigin } from "../types/IFavoriteOrigins";
import { ICarrier } from "../types/ILocation";
import { StoreSlice } from "../types/StoreSlice";
import NitroService from "../utils/nitro.service";
import cookie from "./cookie";

export interface IPopupSlice {
  // ##########################################################################################
  // ## Set selected origin #############################################################################
  // ##########################################################################################
  selectedFavoriteOrigin: IFavoriteOrigin[];
  setSelectedFavoriteOrigin: (
    selectedFavoriteOrigin: IFavoriteOrigin[],
  ) => void;
  // ##########################################################################################
  // ## Set indication history #############################################################################
  // ##########################################################################################
  indicationHistory: any[];
  setIndicationHistory: (indicationHistory: any[]) => void;
  // ##########################################################################################
  // ## Show Add Indication History Panel #############################################################################
  // ##########################################################################################
  showAddIndicationHistoryPanel: boolean;
  setShowAddIndicationHistoryPanel: (
    showAddIndicationHistoryPanel: boolean,
  ) => void;

  // ##########################################################################################
  // ## Show Indication History Panel #############################################################################
  // ##########################################################################################
  showIndicationHistoryPanel: boolean;
  setShowIndicationHistoryPanel: (showIndicationHistoryPanel: boolean) => void;

  // ##########################################################################################
  // ## Map Popup #############################################################################
  // ##########################################################################################
  showMapPopup: boolean;
  setShowMapPopup: (showMapPopup: boolean) => void;

  // ##########################################################################################
  // ## Add location Panel ####################################################################
  // ##########################################################################################
  showAddLocationPanel: boolean;
  setShowAddLocationPanel: (showAddLocationPanel: boolean) => void;

  // Add location panel
  addLocationDetails?: { zipCode: string; cityState: string };
  setAddLocationDetails: (addLocationDetails?: {
    zipCode: string;
    cityState: string;
  }) => void;

  // ##########################################################################################
  // ## Add FOB Indication Panel ##############################################################
  // ##########################################################################################
  showAddFOBIndicationPanel: boolean;
  setShowAddFOBIndicationPanel: (
    showAddFOBIndicationPanel: boolean,
    closeOthers?: boolean,
  ) => void;

  // ##########################################################################################
  // ## Competitive Analysis Panel ############################################################
  // ##########################################################################################
  showCompetitiveAnalysisModal: boolean;
  setShowCompetitiveAnalysisModal: (
    showCompetitiveAnalysisModal: boolean,
  ) => void;

  // ##########################################################################################
  // ## Insight Panel #########################################################################
  // ##########################################################################################
  showInsightsPanel: boolean;
  insightsLocationId?: string | undefined;
  openInsightsPanel: (
    locationId: string,
    tab: "Facility" | "Occupants" | "Logistics",
    editing?: boolean,
  ) => void;
  closeInsightsPanel: () => void;

  insightsPanelTab: "Activity" | "Overview" | "Prices";
  setInsightsPanelTab: (
    insightsPanelTab: "Activity" | "Overview" | "Prices",
  ) => void;

  insightsActivityTab: "Dashboard" | "Orders" | "Opportunities" | "Downloads";
  setInsightsActivityTab: (
    insightsActivityTab: "Dashboard" | "Orders" | "Opportunities" | "Downloads",
  ) => void;

  insightsEditing?: "Facility" | "Occupants" | "Logistics";
  setInsightsEditing: (
    insightsEditing?: "Facility" | "Occupants" | "Logistics",
  ) => void;

  pendingRailStationUpdate?: {
    locationId: string;
    stationName: string;
    stationState: string;
    carriers: ICarrier[];
    scrsId?: string;
    targetRowId?: string;
  };
  setPendingRailStationUpdate: (update?: {
    locationId: string;
    stationName: string;
    stationState: string;
    carriers: ICarrier[];
    scrsId?: string;
    targetRowId?: string;
  }) => void;

  pendingWhereFilterUpdate?: { city: string; state: string };
  setPendingWhereFilterUpdate: (update?: {
    city: string;
    state: string;
  }) => void;

  insightOverviewTab: "Facility" | "ProductStorage" | "Occupants" | "Logistics";
  setInsightOverviewTab: (
    insightOverviewTab:
      | "Facility"
      | "ProductStorage"
      | "Occupants"
      | "Logistics",
  ) => void;

  // ##########################################################################################
  // ## Quotes Panel ##########################################################################
  // ##########################################################################################
  showQuotesPanel: boolean;
  setShowQuotesPanel: (showQuotesPanel: boolean) => void;

  // ##########################################################################################
  // ## Help Panel ############################################################################
  // ##########################################################################################
  showNitroGuidePanel: boolean;
  setShowNitroGuidePanel: (showNitroGuidePanel: boolean) => void;

  showNitroCAGuidePanel: boolean;
  setShowNitroCAGuidePanel: (showNitroCAGuidePanel: boolean) => void;

  showMobileFavoriteOriginPanel: boolean;
  setShowMobileFavoriteOriginPanel: (
    showMobileFavoriteOriginPanel: boolean,
  ) => void;

  showMobileFilterPanel: boolean;
  setShowMobileFilterPanel: (showMobileFilterPanel: boolean) => void;

  showMobileSearchPanel: boolean;
  setShowMobileSearchPanel: (showMobileSearchPanel: boolean) => void;

  multiLocSearchType: "location" | "company";
  setMultiLocSearchType: (searchType: "location" | "company") => void;

  showGuidancePanel: boolean;
  setShowGuidancePanel: (showGuidancePanel: boolean) => void;

  showSettingsPanel: boolean;
  setShowSettingsPanel: (showSettingsPanel: boolean) => void;

  hideSearchPanel: boolean;
  setHideSearchPanel: (hideSearchPanel: boolean) => void;

  hideAllPanels: () => void;

  showInvalidProductPopup: boolean;
  setShowInvalidProductPopup: (showInvalidProductPopup: boolean) => void;

  refetchIndicationHistory: (
    locationId: string,
    locationName: string,
  ) => Promise<void>;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const createPopupSlice: StoreSlice<IPopupSlice> = (set, get) => {
  const initialState = {
    // Selected Favorite Origin
    selectedFavoriteOrigin: [] as IFavoriteOrigin[],

    // Indication History
    indicationHistory: [] as any[],

    // Indication History Panel
    showIndicationHistoryPanel: false,

    // AddIndication History Panel
    showAddIndicationHistoryPanel: false,

    // Map Popup
    showMapPopup: false,

    // Add location Panel
    showAddLocationPanel: false,
    addLocationDetails: undefined,
    showAddFOBIndicationPanel: false,

    // Competitive Analysis Panel
    showCompetitiveAnalysisModal: false,

    // Inights panel
    showInsightsPanel: false,
    insightsPanelTab: "Overview" as any,
    insightsActivityTab: "Dashboard" as any,
    insightOverviewTab: "Logistics" as any,

    // Quotes Panel
    showQuotesPanel: false,

    // Help Panels
    showNitroGuidePanel: cookie.helpGuideShown === undefined,
    showNitroCAGuidePanel: cookie.caHelpGuideShown === undefined,

    showGuidancePanel: false,

    showMobileFavoriteOriginPanel: false,

    showMobileFilterPanel: false,
    showMobileSearchPanel: false,

    showSettingsPanel: false,

    hideSearchPanel: false,

    showInvalidProductPopup: false,
  };

  return {
    ...initialState,

    // ##########################################################################################
    // ## Refetch Indication History ############################################################
    // ##########################################################################################
    refetchIndicationHistory: async (
      locationId: string,
      locationName: string,
    ) => {
      // Use get() to access other parts of the store's state
      const { product, currentFilters } = get() as any; // Cast as any if types are in other slices

      if (!product || !locationId || !currentFilters.month) {
        console.log("Missing required data to fetch indication history.");
        return;
      }

      try {
        const records = await NitroService.getIndicationHistory({
          product,
          locationId,
          shipDate: currentFilters.month,
        });

        const recordsWithOriginName = records.map((record) => ({
          ...record,
          originName: locationName,
        }));

        // Use set() to update the state
        set({ indicationHistory: recordsWithOriginName });
      } catch (error) {
        console.error("Failed to fetch indication history from store:", error);
      }
    },

    // ##########################################################################################
    // ## Set Selected Favorite Origin #############################################################################
    // ##########################################################################################
    setSelectedFavoriteOrigin: (selectedFavoriteOrigin: IFavoriteOrigin[]) => {
      set({ selectedFavoriteOrigin });
    },

    // ##########################################################################################
    // ## Show Add Indication History Panel #############################################################################
    // ##########################################################################################
    setIndicationHistory: (indicationHistory: any[]) => {
      set({ indicationHistory });
    },

    // ##########################################################################################
    // ## Show Add Indication History Panel #############################################################################
    // ##########################################################################################
    setShowAddIndicationHistoryPanel: (
      showAddIndicationHistoryPanel: boolean,
    ) => {
      set({ showAddIndicationHistoryPanel });
    },

    // ##########################################################################################
    // ## Show Indication History Panel #############################################################################
    // ##########################################################################################
    setShowIndicationHistoryPanel: (showIndicationHistoryPanel: boolean) => {
      set({ showIndicationHistoryPanel });
    },

    // ##########################################################################################
    // ## Map Popup #############################################################################
    // ##########################################################################################
    setShowMapPopup: (showMapPopup: boolean) => {
      set({ showMapPopup });
    },

    // ##########################################################################################
    // ## Add location Panel ####################################################################
    // ##########################################################################################
    setShowAddLocationPanel: (showAddLocationPanel: boolean) => {
      const params: any = {
        showInsightsPanel: false,
        showAddLocationPanel,
        showAddFOBIndicationPanel: false,
        showCompetitiveAnalysisModal: false,
        showAddPopup: false,
        showReviewPopup: false,
      };

      if (showAddLocationPanel) {
        // Always open the panel in form mode to avoid stale pin-selection state
        // that can hide the modal content (width: 0) and appear as a blank panel.
        params.selectingPinLocation = false;
        params.pinLocation = undefined;
      }

      if (!showAddLocationPanel) {
        params.pinLocation = undefined;
        params.selectingPinLocation = false;
      }

      set(params);
    },

    setAddLocationDetails: (addLocationDetails?: {
      zipCode: string;
      cityState: string;
    }) => {
      set({ addLocationDetails });
    },

    // ##########################################################################################
    // ## Add FOB Indication Panel ##############################################################
    // ##########################################################################################
    setShowAddFOBIndicationPanel: (
      showAddFOBIndicationPanel: boolean,
      // closeOthers?: boolean
    ) => {
      // if (!closeOthers) {
      //   return set({ showAddFOBIndicationPanel });
      // }

      set({
        // showInsightsPanel: false,
        showAddLocationPanel: false,
        showAddFOBIndicationPanel,
        showCompetitiveAnalysisModal: false,
        showMapPopup: false,
        showIndicationHistoryPanel: false,
        showAddIndicationHistoryPanel: false,
        indicationHistory: [],
        selectedFavoriteOrigin: [],
      });
    },

    // ##########################################################################################
    // ## Competitive Analysis Panel ############################################################
    // ##########################################################################################
    setShowCompetitiveAnalysisModal: (
      showCompetitiveAnalysisModal: boolean,
    ) => {
      const params: any = {
        showInsightsPanel: false,
        showAddLocationPanel: false,
        showAddFOBIndicationPanel: false,
        showCompetitiveAnalysisModal,
      };

      const { currentFilters, mode } = get() as any;

      if (showCompetitiveAnalysisModal) {
        params.currentFilters = {
          ...currentFilters,
        };
        params.mode = mode || "TRUCK";
      }

      set(params);
    },

    // ##########################################################################################
    // ## Insight Panel #########################################################################
    // ##########################################################################################
    openInsightsPanel: (
      locationId: string,
      tab: "Facility" | "Occupants" | "Logistics",
      editing?: boolean,
    ) => {
      set({
        showInsightsPanel: true,
        insightsPanelTab: "Overview",
        insightOverviewTab: tab,
        insightsEditing: editing ? tab : undefined,
        insightsLocationId: locationId,
      });
    },

    setInsightsPanelTab: (
      insightsPanelTab: "Activity" | "Overview" | "Prices",
    ) => {
      set({ insightsPanelTab });
    },
    closeInsightsPanel: () => {
      set({
        insightsPanelTab: "Overview",
        insightsActivityTab: "Dashboard",
        insightOverviewTab: "Logistics",
        showInsightsPanel: false,
        insightsEditing: undefined,
        insightsLocationId: undefined,
        showMapPopup: false,
        showIndicationHistoryPanel: false,
        showAddIndicationHistoryPanel: false,
        indicationHistory: [],
        selectedFavoriteOrigin: [],
      });
    },

    setInsightsActivityTab: (
      insightsActivityTab:
        | "Dashboard"
        | "Orders"
        | "Opportunities"
        | "Downloads",
    ) => {
      set({ insightsActivityTab });
    },

    setInsightsEditing: (
      insightsEditing?: "Facility" | "Occupants" | "Logistics",
    ) => {
      const { showCompetitiveAnalysisModal } = get();

      const updatedState: any = {
        insightsEditing,
      };

      // If CA is open, this means they are quickly trying to edit location
      if (showCompetitiveAnalysisModal) {
        updatedState.showInsightsPanel = false;
      }

      set(updatedState);
    },

    setPendingRailStationUpdate: (update?: {
      locationId: string;
      stationName: string;
      stationState: string;
      carriers: ICarrier[];
      scrsId?: string;
    }) => {
      set({ pendingRailStationUpdate: update });
    },

    setPendingWhereFilterUpdate: (update?: { city: string; state: string }) => {
      set({ pendingWhereFilterUpdate: update });
    },

    setInsightOverviewTab: (
      insightOverviewTab:
        | "ProductStorage"
        | "Occupants"
        | "Logistics"
        | "Facility",
    ) => {
      const { insightsEditing } = get();

      const updated = {
        insightOverviewTab,
        insightsEditing,
      };

      if (insightsEditing === "Facility" && insightOverviewTab !== "Facility") {
        updated.insightsEditing = undefined;
      }

      set(updated);
    },

    // ##########################################################################################
    // ## Quotes Panel ##########################################################################
    // ##########################################################################################
    setShowQuotesPanel: (showQuotesPanel: boolean) => {
      set({
        showQuotesPanel,
      });
    },

    // ##########################################################################################
    // ## Help Panels ############################################################################
    // ##########################################################################################
    setShowNitroGuidePanel: (showNitroGuidePanel: boolean) => {
      cookie.setHelpGuideShown();
      set({ showNitroGuidePanel });
    },

    setShowNitroCAGuidePanel: (showNitroCAGuidePanel: boolean) => {
      cookie.setCAHelpGuideShown();
      set({ showNitroCAGuidePanel });
    },

    setShowGuidancePanel: (showGuidancePanel: boolean) => {
      if (!showGuidancePanel) {
        set({
          showGuidancePanel,
          guidanceLocation: undefined,
        } as any);
      } else {
        set({ showGuidancePanel });
      }
    },

    setShowMobileFavoriteOriginPanel: (
      showMobileFavoriteOriginPanel: boolean,
    ) => {
      set({ showMobileFavoriteOriginPanel });
    },

    setShowMobileFilterPanel: (showMobileFilterPanel: boolean) => {
      set({ showMobileFilterPanel });
    },

    setShowMobileSearchPanel: (showMobileSearchPanel: boolean) => {
      set({ showMobileSearchPanel });
    },

    multiLocSearchType: "location",
    setMultiLocSearchType: (searchType: "location" | "company") => {
      set({ multiLocSearchType: searchType });
    },

    setShowSettingsPanel: (showSettingsPanel: boolean) => {
      set({ showSettingsPanel });
    },

    setHideSearchPanel: (hideSearchPanel: boolean) => {
      set({ hideSearchPanel });
    },

    hideAllPanels: () => {
      set({
        showCompetitiveAnalysisModal: false,
        showInsightsPanel: false,
        showQuotesPanel: false,
        showAddLocationPanel: false,
        showAddFOBIndicationPanel: false,
        showSettingsPanel: false,
      });
    },

    setShowInvalidProductPopup: (showInvalidProductPopup: boolean) => {
      set({ showInvalidProductPopup });
    },
  };
};
